import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "Scholarships"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScholarshipEditor = _resolveComponent("ScholarshipEditor")!
  const _component_ScholarshipOverview = _resolveComponent("ScholarshipOverview")!

  return (_ctx.isUserSessionValid)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.page == 'ScholarshipEditor')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ScholarshipEditor)
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.page == 'ScholarshipOverview')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_ScholarshipOverview)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, "Invalid user session"))
}